<template>
    <div>
        <navbar @logout="logout"></navbar>
        <boards 
            :tasks="tasks" 
            :errors="errors"
            @create-new-todo="createNewTodo" 
            @edit-todo="editTodo"
            @delete-task="deleteTask"
            @on-drop="onDrop"
            @start-drag="startDrag"
            ref="boards"
            ></boards>
    </div>
</template>

<script>
import navbar from '../components/navbar.vue';
import boards from '../components/boards.vue';
export default {
    name: "dashboard",
    components: {navbar, boards},
    props:["tasks","errors"],
    data() {
        return {
        message: 'Hello world',
        };
    },
    methods : {
        createNewTodo(data){
            this.$emit('create-new-todo',data)
        },
        editTodo(data){
            this.$emit('edit-todo',data)
        },
        deleteTask(id){
            this.$emit('delete-task',id)
        },
        logout(){
            this.$emit('logout')
        },
        startDrag(ev, item) {
            this.$emit('start-drag',ev, item)
        },
        onDrop (ev, category) {
            this.$emit('on-drop',ev,category)
        },
        showModalError(){
            this.$refs.boards.showModalError()
        }
    }
};
</script>

<style scoped>
</style>